import "./sentry"; // MUST be first — wires global error/perf handlers before any app code runs
import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import { installPrefetchAdapter } from "./services/prefetch";

// Wire the invisible route-level prefetch cache. Bottom-nav slots fire
// prefetch() on touchstart; consumer pages get the warm response without
// any code changes.
installPrefetchAdapter();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
